import React from "react";

function Credits( { } )
{
  return (
    <div className="credits">
      <div className="source">SOURCES: College Scorecard, Clearbit</div>
      <div></div>
      <div className="source credit">DAIN SAINT / STAFF</div>
    </div>

  )
}

export default Credits;
